import { GlobalRouter } from '@okapi/router-react';
import { combineReducers } from 'redux';
import { createReducer as createCookieReducer } from 'isomorphic-redux-cookie-middleware';
import { createReducer as createRouterReducer } from '@okapi/router-connect';
import { createReducer } from 'typesafe-actions';
import { featuresReducer } from 'features';
import { errorsHookReducer } from 'features/errors-hook';
import { Layers } from './header-middleware/types';

export type Env = {
  ORCHESTRATOR_HOST: string;
  ORCHESTRATOR_HOST_KZ?: string;
  ORCHESTRATOR_BACKEND_HOST: string;
  MEDIA_CLOUDINARY_CLOUD: string;
  USE_CREDENTIALS: boolean;
  requestID: string;
  API_KEY?: string;
  requestUrl?: string;
  SERVER_FETCH_DATA_TIMEOUT: number;
  CLIENT_LOG_LEVEL?: string;
  FLOWBOX_KEY?: string;
  CDN_HOST?: string;
  EXPERIMENTS_DOMAIN?: string;
  ROBOTINT_CLIENT_ID: string;
  ROBOTINT_SECRET: string;
  ROBOTINT_LINK: string;
};

export const rootReducer = ({
  host,
  globalRouter,
  isBot,
  env,
  userAgent,
  cookie,
  layers,
  uuid,
}: {
  host: string;
  globalRouter: GlobalRouter;
  isBot: boolean;
  env: Env;
  userAgent: string;
  cookie: string;
  layers: Layers;
  uuid?: string;
}) =>
  combineReducers({
    pdp: featuresReducer,
    router: createRouterReducer(globalRouter),
    host: createReducer(host),
    isBot: createReducer(isBot),
    env: createReducer(env),
    userAgent: createReducer(userAgent),
    cookie: createReducer(cookie),
    cookieParsed: createCookieReducer(cookie),
    layers: createReducer(layers),
    errorsHook: errorsHookReducer,
    experimentsUUID: createReducer(uuid),
  });

export type RootReducer = ReturnType<ReturnType<typeof rootReducer>>;
